import { render, staticRenderFns } from "./ModalTransfer.vue?vue&type=template&id=1cbbe36a&scoped=true"
import script from "./ModalTransfer.vue?vue&type=script&lang=js"
export * from "./ModalTransfer.vue?vue&type=script&lang=js"
import style0 from "./ModalTransfer.vue?vue&type=style&index=0&id=1cbbe36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbbe36a",
  null
  
)

export default component.exports